import ExcelJS from "exceljs"
import fileDownload from "js-file-download"
import moment from "moment"
import { useState } from "react"
import { customToast } from "../../../components/Toast"
import Send from "../../communication"
import { jsonToExcel } from "../jsonToExcel"
import { getIds } from "../getIds"
import { useParams } from "react-router-dom";

export const exportUsersMagicLinks = (data, nameFile = "users_magic_link_") => {
  const [loadingExport, setExporting] = useState(false)
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("ManejeSheet")

  const exportUsers = async () => {
    if (!data) {
      return
    }

    let dataJson = data
      .sort((a, b) => {
        if (!b.name) {
          return -1
        } else if (a.name >= b.name) {
          return -1
        }
        return a.name <= b.name
      })
      .map((item) => {
        return {
          name: item?.name,
          email: item?.email,
          magicLink: item?.dynamicLink || "",
        }
      })

    const columns = [
      { header: "Nome", key: "name", width: 60 },
      { header: "Email", key: "email", width: 60 },
      { header: "Projeto", key: "project", width: 40 },
      { header: "Link Mágico", key: "magicLink", width: 100 },
    ]

    worksheet.columns = columns

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 12,
      bold: true,
      color: { argb: "#000000" },
    }

    dataJson.map((row) => {
      worksheet.addRow(row)
    })

    worksheet.autoFilter = {
      from: "A1",
      to: "Z1",
    }
    setExporting(true)
    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, `${nameFile}${Date.now()}.xlsx`)
    setExporting(false)
  }

  return { exportUsers, loadingExport }
}

export const exportUsersProject = (data, nameFile = "users_engagement_") => {
  const [loadingExport, setExporting] = useState(false)
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("ManejeSheet")

  const exportUsers = async () => {
    if (!data) {
      return
    }

    let dataJson = data
      // .sort((a, b) => {
      //   if (!b.analytics?.event_timestamp) {
      //     return -1
      //   } else if (a.analytics?.event_timestamp >= b.analytics?.event_timestamp) {
      //     return -1
      //   }
      //   return a.analytics?.event_timestamp <= b.analytics?.event_timestamp
      // })
      .map((item) => {
        return {
          id: item?.userId || item?.id,
          name: item?.name,
          email: item?.email,
          state: item?.state,
          cpf: item?.document,
          phone: item?.phone || "Sem Telefone Cadastrado",
          whatsapp: item?.whatsapp || "Sem WhatsApp Cadastrado",
          city: item?.city || "Sem Cidade Cadastrada",
          project: item.project,
          projectId: item.projectId || "",
          tags: item.tag_user
            ? item.tag_user.map(({ name }) => name).filter((item) => item !== null)
            : [],
          lastEvent: item?.analytics?.event_timestamp
            ? moment(new Date(item?.analytics?.event_timestamp / 1000)).format("DD/MM/YYYY")
            : "Inativo",
        }
      })

    const columns = [
      { header: "ID", key: "id", width: 50 },
      { header: "Nome", key: "name", width: 60 },
      { header: "CPF", key: "cpf", width: 60 },
      { header: "Email", key: "email", width: 60 },
      { header: "Telefone", key: "phone", width: 40 },
      { header: "WhatsApp", key: "whatsapp", width: 40 },
      { header: "Cidade", key: "city", width: 40 },
      { header: "Estado", key: "state", width: 40 },
      { header: "Projeto", key: "project", width: 40 },
      { header: "IdProjeto", key: "projectId", width: 40 },
      { header: "Ultimo Evento", key: "lastEvent", width: 40 },
      { header: "Tags do Usuário", key: "tags", width: 100 },
    ]

    worksheet.columns = columns

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 12,
      bold: true,
      color: { argb: "#000000" },
    }

    dataJson.map((row) => {
      worksheet.addRow(row)
    })

    worksheet.autoFilter = {
      from: "A1",
      to: "Z1",
    }
    setExporting(true)
    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, `${nameFile}${Date.now()}.xlsx`)
    setExporting(false)
  }

  return { exportUsers, loadingExport }
}

export const exportUsersTraining = (usersProject, desc) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("ManejeSheet")

  const usersTraining = async () => {
    worksheet.columns = [
      { header: "Nome", key: "name", width: 40 },
      { header: "Usuario", key: "user", width: 40 },
      { header: "Link", key: "link", width: 40 },
    ]

    const columns = ["Nome", "User", "Link"]

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 12,
      bold: true,
      color: { argb: "#000000" },
    }

    usersProject.map(({ user, project }) => {
      const addData = worksheet.addRow()
      for (let i = 0; i < columns.length; i++) {
        let cell = addData.getCell(i + 1)

        if (i == 0) {
          cell.value = user?.name
        } else if (i == 1) {
          cell.value = user?.id
        } else if (i == 2) {
          cell.value = `https://manejebem.netlify.app/treinamento?idUser=${user?.id}&idProject=${project?.id
            }&description=${encodeURI(desc)}`
        } else {
          cell.value = ""
        }
      }
    })

    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, "UsuáriosTreinadosProjetos.xlsx")
  }

  return usersTraining
}

export const exportUsersSupplier = (scope) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("ManejeSheet")

  const usersSupplier = async () => {
    if (scope?.id !== "3ac327ae-87d5-463e-b5c7-0ce54fa205d9") {
      customToast("Projeto não autorizado!", "warning")
      return
    }

    const data = await Send.get("/dw/report?id=76").then((data) => {
      return data.map((item) => ({
        ...item,
        estado: item.estado ? `(BR) ${item.estado}` : "",
        country: "BRAZIL",
        abiCrop: "Cassava",
        datasource: "Excel",
        typeOfGrower: "Smallholder",
        aprovedVariety: "TRUE",
        technicalVisits: `${item.Trilha}`.toLowerCase().includes("conectado") ? "TRUE" : "FALSE",
        registeredSmartBarley: "FALSE",
        alternativePlatform: "FALSE",
        messagingProgram: `${item.Trilha}`.toLowerCase().includes("conectado") ? "TRUE" : "FALSE",
        businessSkillsTraining: `${item.Trilha}`.toLowerCase().includes("empoderado")
          ? "TRUE"
          : "FALSE",
        subscribeFinancialCM: "FALSE",
      }))
    })

    const columns = [
      { header: "Unique Id", key: "Documento", width: 20 },
      { header: "First Name", key: "Nome", width: 30 },
      { header: "Last Name", key: "Sobrenome", width: 60 },
      { header: "Country", key: "country" },
      { header: "State ((Country acronym) + State)", key: "estado", width: 30 },
      { header: "Town/Village", key: "cidade", width: 30 },
      { header: "Gender (M/F)", key: "gender" },
      { header: "ABI Crop", key: "abiCrop" },
      { header: "Agronomist E-mail", key: "agronomistEmail" },
      { header: "Phone Number", key: "Telefone", width: 20 },
      { header: "E-mail", key: "email" },
      { header: "Data Source", key: "datasource" },
      { header: "Type of Grower (Commercial/Smallholder)", key: "typeOfGrower" },
      { header: "Reporting Month (MM/YY)", key: "reportingMonth" },
      { header: "Reporting Year (YYYY)", key: "reportingYear" },
      { header: "Aproved Variety? (TRUE/FALSE)", key: "aprovedVariety" },
      { header: "Crop Protocol? (TRUE/FALSE)", key: "cropProtocol" },
      { header: "Technical Visits (TRUE/FALSE)", key: "technicalVisits" },
      { header: "Registered on SmartBarley? (TRUE/FALSE)", key: "registeredSmartBarley" },
      { header: "Alternative Digital Platform? (TRUE/FALSE)", key: "alternativePlatform" },
      { header: "SH - SMS/Voice Messaging Program? (TRUE/FALSE)", key: "messagingProgram" },
      {
        header: "SH - Business & Financial Skills Training? (TRUE/FALSE)",
        key: "businessSkillsTraining",
      },
      {
        header: "SH - Subscribe to Financial Product/Solution (TRUE/FALSE)",
        key: "subscribeFinancial",
      },
      {
        header: "CM - Subscribe to Financial Product/Solution? (TRUE/ FALSE)",
        key: "subscribeFinancialCM",
      },
    ]
    worksheet.columns = columns

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 12,
      bold: true,
      color: { argb: "#000000" },
    }

    data.map((row) => {
      worksheet.addRow(row)
    })

    worksheet.autoFilter = {
      from: "A1",
      to: "Z1",
    }

    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, `user_supplier_data_${Date.now()}.xlsx`)
  }

  return usersSupplier
}

export const exportSelectedForms = () => {
  const [loading, setLoading] = useState(false)

  const exportForms = async (values) => {
    if (values.projects && values.projects.length > 0) {
      let extraProps = ""
      if (values.questions && values.questions.length > 0) {
        extraProps += `&questions=${getIds(values.questions)}`
      }

      if (values.farmers && values.farmers.length > 0) {
        extraProps += `&farmers=${getIds(values.farmers)}`
      }

      if (values.forms && values.forms.length > 0) {
        extraProps += `&forms=${getIds(values.forms)}`
      }

      if (values.tags && values.tags.length > 0) {
        extraProps += `&tags=${getIds(values.tags)}`
      }

      setLoading(true)
      const dw = Send.get("/dw/data/export", `projects=${getIds(values.projects)}${extraProps}`)

      await Promise.all([dw])
        .then(async ([dw]) => {
          if (values.year && values.year.split("|").length === 2) {
            const [startDate, endDate] = values.year.split("|")

            dw = dw.filter((item) => {
              const dataItem = item.Data && item.Data.value

              // Verifica se a data existe e se está dentro do intervalo usando moment
              return dataItem && moment(dataItem).isBetween(startDate, endDate, "day", "[]")
            })
          }
          const formattedDw = dw.map((item) => ({
            ...item,
            Data: (item.Data && item.Data.value) || "",
            Mes: item.Data ? item.Data.value.slice(5, 7) + "-" + item.Data.value.slice(0, 4) : "",
            Pergunta: item.Pergunta.replace(/^[^:]+:\s*/, ""),
          }))
          console.log({ formattedDw })
          await jsonToExcel("Dados brutos", formattedDw)
        })
        .catch((e) => {
          console.log({ e })
        })
      setLoading(false)
    } else {
      customToast("Selecione um ou mais projetos!", "warning")
      // alert("Selecione um ou mais projetos!")
    }
  }

  return { exportForms, loading }
}

export const exportPlanActions = (data, nameFile = "link_") => {
  const { userId } = useParams()
  const [loading, setLoading] = useState(false)
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("ManejeSheet")

  const exportPlan = async () => {
    if (!data) {
      return
    }

    setLoading(true)
    let dataJson = data.map((item) => {
      return {
        project: item?.project,
        producerName: item?.producerName,
        title: item?.title,
        finish_at: item?.finish_at ? moment(item?.finish_at).format("DD/MM/YYYY") : "",
        email: item?.email || "",
        isComplete: item?.isComplete ? "Concluído" : "Não concluído",
        location: item?.location || "",
        instructions: item?.instructions || "",
        why: item?.why || "",
        tags: typeof item?.tags === "string" ? JSON.parse(item?.tags).join(", ") : "",
      }
    })

    const showCollumns = !userId ? [
      { header: "Projeto", key: "project", width: 80 },
      { header: "Produtor", key: "producerName", width: 80 },
    ] : []

    const columns = [
      ...showCollumns,
      { header: "Título", key: "title", width: 80 },
      { header: "Termina em", key: "finish_at", width: 60 },
      { header: "Responsável", key: "email", width: 80 },
      { header: "Status", key: "isComplete", width: 40 },
      { header: "Onde será realizada a ação", key: "location", width: 100 },
      { header: "Como será realizada a ação?", key: "instructions", width: 100 },
      { header: "Porque realizará a ação?", key: "why", width: 100 },
      { header: "Tags", key: "tags", width: 80 },
    ]

    worksheet.columns = columns

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 12,
      bold: true,
      color: { argb: "#000000" },
    }

    dataJson.map((row) => {
      worksheet.addRow(row)
    })

    worksheet.autoFilter = {
      from: "A1",
      to: "Z1",
    }
    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, `${nameFile}${Date.now()}.xlsx`)
    setLoading(false)
  }

  return { exportPlan, loading }
}

export const exportContentSent = (data, isBeneficiary = false, nameFile = "content_sent_") => {
  const [loading, setLoading] = useState(false)
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("ManejeSheet")

  const getColumns = () => {
    const baseColumns = [
      { header: "Data de Envio", key: "DataEnvio", width: 60 },
      { header: "Data de Leitura", key: "DataLeitura", width: 60 },
      { header: "Técnico", key: "Tecnico", width: 80 },
      { header: "Projeto", key: "Projeto", width: 100 },
    ]

    return [
      { header: "Beneficiário", key: "Beneficiario", width: 80 },
      { header: "Conteúdo", key: "Conteudo", width: 200 },
      ...baseColumns,
    ]
  }

  const getDataJson = () => {
    return data.flatMap((item) =>
      (item.data ?? []).map((subItem) => ({
        Beneficiario: isBeneficiary ? item.beneficiary : subItem?.beneficiary || "",
        Conteudo: isBeneficiary ? subItem?.content || "" : item.content,
        DataEnvio: subItem?.send_data ? moment(subItem?.send_data).format("DD/MM/YYYY") : "",
        DataLeitura: subItem?.read_data ? moment(subItem?.read_data).format("DD/MM/YYYY") : "",
        Tecnico: subItem?.technician || "",
        Projeto: subItem?.project || "",
      })),
    )
  }

  const exportContent = async () => {
    if (!data || data.length === 0) return

    setLoading(true)

    const dataJson = getDataJson()
    const columns = getColumns()

    worksheet.columns = columns

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 12,
      bold: true,
      color: { argb: "#000000" },
    }

    dataJson.forEach((row) => {
      worksheet.addRow(row)
    })

    worksheet.autoFilter = {
      from: "A1",
      to: "Z1",
    }

    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, `${nameFile}${Date.now()}.xlsx`)
    setLoading(false)
  }

  return { exportContent, loading }
}

export const exportAssistanceTable = (data) => {
  const [loading, setLoading] = useState(false)
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("ManejeSheet")

  const getColumns = () => {
    return [
      { header: "Nome do produtor", key: "NomeProdutor", width: 60 },
      { header: "Data do atendimento", key: "Data", width: 60 },
      { header: "Projeto", key: "Projeto", width: 60 },
      { header: "Técnico", key: "Tecnico", width: 80 },
      { header: "Tipo de atendimento", key: "Tipoatendimento", width: 100 },
      // { header: "Link", key: "Link", width: 100 },
    ]

  }

  const getDataJson = () => {
    return data.map((item) => ({
      "NomeProdutor": item?.NomeProdutor || "",
      "Data": item?.data ? new Date(item.data.value).toLocaleDateString() : "-",
      "Projeto": item?.projeto || "-",
      "Tecnico": item?.nomeResponsavel || "-",
      "Tipoatendimento": item?.acao || "-",
      // "Link": item?.link || "-"
    }),
    )
  }


  const exportAssistance = async () => {
    if (!data || data.length === 0) return

    setLoading(true)

    const dataJson = getDataJson()
    const columns = getColumns()

    worksheet.columns = columns

    worksheet.getRow(1).font = {
      name: "Lato",
      size: 12,
      bold: true,
      color: { argb: "#000000" },
    }

    dataJson.forEach((row) => {
      worksheet.addRow(row)
    })

    worksheet.autoFilter = {
      from: "A1",
      to: "Z1",
    }

    const bufferData = await workbook.xlsx.writeBuffer()
    fileDownload(bufferData, `Atendimentos_Detalhados${Date.now()}.xlsx`)
    setLoading(false)
  }

  return { exportAssistance, assistanceTableLoading:loading }
}